import { type CardProps } from "@tokenterminal/ui/Card"
import { CollapsableWidget } from "modules/Widget"
import { type ReactNode } from "react"
import { asideCard } from "./AsideCard.css"
import type { OmitStrict } from "modules/analytics/types"

export interface AsideCardProps
  extends OmitStrict<CardProps, "children" | "title"> {
  title: NonNullable<ReactNode>
  children: ReactNode
  isDefaultOpen?: boolean
  isDefaultOpenInMobile?: boolean // TODO: dont use this, but rather display without accordion when this is true
}

export const AsideCard = ({
  className: _, // Dont allow at least for now
  title,
  children,
  isDefaultOpen = true,
  isDefaultOpenInMobile = false,
  ...props
}: AsideCardProps) => {
  return (
    <CollapsableWidget
      direction="left"
      header={title}
      isDefaultOpen
      className={asideCard}
      {...props}
    >
      {children}
    </CollapsableWidget>
  )
}
